import {Component, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {Subject} from 'rxjs/Subject';
import {Subscription} from 'rxjs/Subscription';
import {AddTransactionComponent} from '../../../../../modals/add-transaction/add-transaction.component';
import {HcaMemberService} from '../../../../../../shared/_services/hca-member.service';
import {StatusModalComponent} from '../../../../../modals/status-modal/status-modal.component';
import {MessageModalComponent} from '../../../../../modals/message-modal/message-modal.component';
import {DetailsModalComponent} from '../../../../../modals/details-modal/details-modal.component';
import {environment} from '../../../../../../../environments/environment';
import {UtilService} from '../../../../../../shared/_services/util.service';

@Component({
  selector: 'app-members-old-transaction-history',
  templateUrl: './members-old-transaction-history.component.html',
  styleUrls: ['./members-old-transaction-history.component.scss']
})
export class MembersOldTransactionHistoryComponent implements OnInit {
  notes: any;
  memberSubscription: Subscription;
  memberInfo: any;
  totalCount: number;
  p = 0;
  size = 10;
  transactionList: any[];
  memberId: string | number;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  destroySubscription$: Subject<boolean> = new Subject();
  user: any;
  role: any;

  constructor(
    private hcaMemberService: HcaMemberService,
    private modalService: BsModalService,
    private utilService: UtilService,
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action === 'action1') {
            if (this.statusModal.content.srcObject.type === 'member-edit') {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status === 0) {
                const status = +this.statusModal.content.srcObject.status;
                this.updateTransactionStatus(this.statusModal.content.srcObject.id, status);
              } else {
                this.getOldTransactionHistory();
              }
            } else {
              this.getOldTransactionHistory();
            }
          }
        }
      });
  }

  updateTransactionStatus(transactionId, statusId) {
    console.log(`change status for ${transactionId} to ${statusId === 0 ? 'Deactivate' : 'Activate'}`);
    this.hcaMemberService.updateTransactionStatus(transactionId, statusId).subscribe(res => {
      this.getOldTransactionHistory();
    }, err => {
      console.error('Error while updating promotion status: ', err.message);
      this.openErrorModal(err.message);
    });
  }

  updateBadgeStatus(memberId, type) {
    this.hcaMemberService.updateBadgeEvents(memberId, type).subscribe(res => {
      if (res.error === 0) {
        this.memberInfo = res.responseObj;
        this.hcaMemberService.setMember(this.memberInfo);
      }
    }, err => {
      console.error('Error while updating member issue status by Id: ', err.message);
    });
  }

  getOldTransactionHistory(pageNum?) {
    this.p = pageNum ? pageNum : this.p;
    if (this.memberInfo && this.memberInfo.manualPoints) {
      this.updateBadgeStatus(this.memberId, 'manualPoints');
    }
    this.hcaMemberService.getOldTransactionHistory(this.p > 0 ? this.p - 1 : this.p, this.memberId).subscribe(res => {
      if (res.error === 0) {
        this.transactionList = res.responseObj && res.responseObj.results && res.responseObj.results.length ? res.responseObj.results : [];
        this.totalCount = res.responseObj && res.responseObj.totalRecords ? res.responseObj.totalRecords : 0;
        console.log(this.transactionList);
      }
    }, err => {
      console.error('Error while getting transaction list with member id: ', err.message);
    });

  }

  openStatusModal(id?, mode?, statusType?) {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    const message = `Are you sure you want to ${statusType.toLowerCase()} this transaction?`;
    const title = `${statusType} Transaction`;
    const action1 = `${statusType}`;
    const style = (mode === 0 || mode === 3 || mode === 4) ? 'inactive' : 'active';
    const status = mode;
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'member-edit',
      title: title,
      message: message,
      status,
      id,
      action1: action1 === 'Cancel' ? 'Confirm' : action1,
      action2: 'Cancel',
      action: '',
      style: style
    };
  }

  openErrorModal(customMsg?: string) {
    this.statusModal = this.modalService.show(MessageModalComponent, {class: 'confirm-modal'});
    let message;
    if (customMsg) {
      message = customMsg;
    } else {
      message = `Transaction has already been Approved `;
    }

    this.statusModal.content.srcObject = {
      mode: 'custom',
      message: message,
      action2: 'Close',
    };
  }

  openDetailsModal(notes) {
    this.notes = JSON.parse(notes);
    this.statusModal = this.modalService.show(DetailsModalComponent, {class: 'confirm-modal'});
    const title = `Transaction Details`;
    const message = ` Description : ${this.notes.description}`;
    const message1 = `DiscountCode : ${this.notes.discountCode}`;
    const message2 = `Hotel : ${this.notes.hotel}`;
    const message3 = `Reservation : ${this.notes.reservation}`;
    const message4 = `Value : ${this.notes.value}`;
    this.statusModal.content.srcObject = {
      mode: 'custom',
      message: message,
      message1: message1,
      message2: message2,
      message3: message3,
      message4: message4,
      action2: 'Close',
      title: title
    };
  }

  checkDiscountStatus(transId) {
    this.hcaMemberService.checkDiscountStatus(transId).subscribe(res => {
      if (res.error === 0) {
        this.statusModal = this.modalService.show(DetailsModalComponent, {class: 'confirm-modal'});
        const title = `Discount Status`;
        const message = res.message;
        this.statusModal.content.srcObject = {
          message: message,
          mode: 'custom',
          action2: 'Close',
          title: title
        };
      }
    }, err => {
      console.error('Error while getting transaction list with member id: ', err.message);
      this.statusModal = this.modalService.show(DetailsModalComponent, {class: 'confirm-modal'});
      const title = `Discount Status`;
      const message = err.message;
      this.statusModal.content.srcObject = {
        message: message,
        mode: 'custom',
        action2: 'Close',
        title: title
      };
    });
  }

  openModalAddTransaction() {
    this.statusModal = this.modalService.show(AddTransactionComponent, {class: 'add-transaction-modal'});
    if (this.memberId) {
      this.statusModal.content.memberId = this.memberId;
    }
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('loggedInUser'));
    this.role = this.utilService.parseJwt(this.user.token).info.roles;
    this.memberId = this.hcaMemberService.getMemberId;
    this.memberInfo = this.hcaMemberService.getMemberInfo;
    this.getOldTransactionHistory();
    this.memberSubscription = this.hcaMemberService.memberData$
      .takeUntil(this.destroySubscription$)
      .subscribe((state: any) => {
        if (state) {
          this.memberInfo = state;
          if (this.memberInfo && this.memberInfo.manualPoints) {
            this.updateBadgeStatus(this.memberId, 'manualPoints');
          }
        }
      });
  }

  voucherDownload(transactionId) {
    console.log(`Getting voucher for transaction ${transactionId}`);
    this.hcaMemberService.getVoucherDownload(transactionId).subscribe(
      data => this.downloadFile(data)
      , err => {
        console.error('Error while genrating voucher : ', err.message);
        this.openErrorModal('Having the issue with voucher genration, try later');
      });
  }

  downloadFile(data: any) {
    window.open(environment.VOUCHER_PDF_LINK + data.responseObj, '_block');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/concierge/members-management/members-old-transaction-history/members-old-transaction-history.component.ts